import React from 'react';
import {reduxForm, Field} from 'redux-form';
import {connect} from 'react-redux';
import { Link } from 'react-router-dom';
import {userLoginAttempt} from "../../actions/actions";
import {renderField} from "../../form";

const mapStateToProps = state => ({
  ...state.auth
});

const mapDispatchToProps = {
  userLoginAttempt
};

class Login extends React.Component {
  componentDidUpdate(prevProps) {
    if (prevProps.token !== this.props.token) {
      this.props.history.push('/');
    }
  }

  onSubmit(values) {
    return this.props.userLoginAttempt(
      values.username,
      values.password
    );
  }

  render() {
    const {handleSubmit, error} = this.props;

    return (
      <div className="user-box">
        <Link to="/" className="close">x</Link>
        {error && <div className="alert alert-danger">{error}</div>}
        <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
          <Field name="username" label="E-mail" type="text" component={renderField} />
          <Field name="password" label="Password" type="password" component={renderField} />
          <button type="submit" className="form-button">Zaloguj</button>
        </form>
      </div>
    )
  }
}

export default reduxForm({
  form: 'Login'
})(connect(mapStateToProps, mapDispatchToProps)(Login));
